import PropTypes from 'prop-types'

export default PropTypes.shape({
  bayNumber: PropTypes.number.isRequired,
  deviceId: PropTypes.string.isRequired,
  deviceName: PropTypes.string.isRequired,
  lockedAt: PropTypes.string,
})
